import { Injectable } from '@angular/core';
import { RoutingService } from '@barthauer/basys/map-frame';
import { Observable, Subject } from 'rxjs';
import { AppService } from '../services/app.service';
import { FrameService } from '../services/frame.service';
import { ResourcesDataContext, ResourcesNavigationContext } from './resources.model';
@Injectable()
export class ResourcesService {
  public context: ResourcesNavigationContext;
  private dataContextSubject = new Subject<ResourcesDataContext>();
  private refreshNavigationContextSubject = new Subject<ResourcesNavigationContext>();
  constructor(private routingService: RoutingService, private frame: FrameService) {
    this.frame.bottomSheetTogglePreparations = () => this.ensureDiscardResourceEventWhenNavigateBack();
  }

  public ensureDiscardResourceEventWhenNavigateBack() {
    if (this.context?.discardResourceEventWhenNavigateBack) {
      console.log('temp. ResourceEvent discarded');
      this.context.resourceEventGroup.removeResourceEvent(this.context.resourceEventIndexInGroup);
      this.context.discardResourceEventWhenNavigateBack = false;
    }
  }

  sendDataContext(dataContext: ResourcesDataContext) {
    this.dataContextSubject.next(dataContext);
  }

  onDataContextSent(): Observable<ResourcesDataContext> {
    return this.dataContextSubject.asObservable();
  }

  refreshNavigationContext(context: ResourcesNavigationContext) {
    this.context = context;
    this.refreshNavigationContextSubject.next(this.context);
  }

  onNavigationContextRefresh(): Observable<ResourcesNavigationContext> {
    return this.refreshNavigationContextSubject.asObservable();
  }

  navigateTo(target: string) {
    const current = this.routingService.getCurrentConfig();
    if (target !== current.designation) {
      if (target === AppService.Route_ResourceList) {
        this.ensureDiscardResourceEventWhenNavigateBack();
      }
      this.frame.ensurePersistingState(() => this.internalNavigateTo(target));
    }
  }

  navigateContext(increment: number) {
    this.frame.ensurePersistingState(() => this.internalNavigateContext(increment));
  }

  navigateContextSpecific(index: number) {
    this.frame.ensurePersistingState(() => this.internalNavigateContextSpecific(index));
  }

  private internalNavigateTo(target: string) {
    if (
      target === AppService.Route_ResourceEventMaterialMaterialExpense ||
      target === AppService.Route_ResourceEventPersonnelWorkingTimes ||
      target === AppService.Route_ResourceEventVehicleDowntime ||
      target === AppService.Route_ResourceEventVehicleMileage ||
      target === AppService.Route_ResourceEventVehicleOperatingHours ||
      target === AppService.Route_ResourceEventVehicleWaterFilling ||
      target === AppService.Route_ResourceEventOtherOther
    ) {
      this.routingService.navigateName(target).then((succ) => {
        if (succ) {
          this.refreshNavigationContext(this.context);
        }
      });
    } else {
      this.routingService.navigateName(target);
    }
  }

  private internalNavigateContext(increment: number) {
    this.internalNavigateContextSpecific(this.context.resourceEventIndexInGroup + increment);
  }
  private internalNavigateContextSpecific(index: number) {
    this.context.resourceEventIndexInGroup = index;
    this.refreshNavigationContext(this.context);
  }
}
